import { Component, HostBinding, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { ConfirmationService } from '../../../core/services/confirmation.service';
import { DIALOG_TOKEN } from '../../tokens';
import { ConfType } from '@models/*';
import { entryHeightAnimation, fadeInOutAnimation } from '@animations/*';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-data-collecting-confirmation-dialog',
    templateUrl: './data-collecting-confirmation-dialog.component.html',
    styleUrls: ['./data-collecting-confirmation-dialog.component.scss'],
    animations: [fadeInOutAnimation, entryHeightAnimation]
})
export class DataCollectingConfirmationDialogComponent implements OnInit {
    @HostBinding('@fadeInOut') fadeInOutAnimation;
    @HostBinding('class') class = 'foreground';

    type: ConfType;
    confirmationType = ConfType;

    constructor(
        private confirmationService: ConfirmationService,
        @Inject(DIALOG_TOKEN) public injectedData: {
            insertionRef: ViewContainerRef,
            insertionIndex: number,
            type: ConfType,
            extras?: { [k: string]: any }
        }
    ) {
    }

    initValue: number = this.injectedData.extras && this.injectedData.extras.initValue;

    form = new UntypedFormGroup({
        kmState: new UntypedFormControl(
            this.initValue || 0,
            Validators.compose([
                Validators.min(this.initValue || 1),
                Validators.required
            ])
        )
    });

    ngOnInit() {
        this.type = this.injectedData.type;

        if (parseInt(this.form.value.kmState) == 0) {
            this.form.get('kmState').patchValue('');
        }

        if (this.type === ConfType.END_SHIFT) {
            this.form.addControl('nightStay', new UntypedFormControl(false));
            // this.form.get('kmState').hasError('min') || this.form.get('kmState').hasError('required');
        }
    }

    public confirm(): void {
        const conf = {
            type: this.injectedData.type,
            data: {
                registeredKms: this.form.value.kmState,
                nightStay: this.form.value.nightStay
            }
        };
        this.confirmationService.sendConfirmation(conf);
        this.injectedData.insertionRef.remove(this.injectedData.insertionIndex);
    }

    public reject(): void {
        const conf = { type: ConfType.CANCEL_CONFIRMATION, data: null };
        this.confirmationService.sendConfirmation(conf);
        this.injectedData.insertionRef.remove(this.injectedData.insertionIndex);
    }

    get isErrorShown(): boolean {
        return this.form.get('kmState').hasError('min') || this.form.get('kmState').hasError('required');
    }

}
